import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog,MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { getDeviceDetailsReq, saveTemplateSpace} from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage } from '../../../../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../../../../api.service';
import { NewDeviceTypeDesc,DeviceType,appsettings } from '../../../../../app-settings';

@Component({
  selector: 'app-template-unit',
  templateUrl: './template-unit.component.html',
  styleUrls: ['./template-unit.component.scss']
})
export class TemplateUnitComponent implements OnInit {

  public unitTempateForm : FormGroup;
  selectedUnitId;
  selectedFloorId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  DevicesInfo;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  device_list_all="3"
  minheight = "350px"; 
  rowHeight = "79px";
  checkspacetempselectall = false;
  checkspacetempinfo = false;
  select_DeviceIds = [];
  selectedFloorName;
  spacetempcountchecked_id = 0;
  SpaceImageName;
  DeviceInfowithoutZone = [];
  selectCampusId;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<TemplateUnitComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog,private apiService: ApiService) { 
    
      this.selectCampusId = data.CampusId;
      this.selectedUnitId = data.UnitId;
      this.selectedFloorId = data.FloorId;
      this.selectedFloorName = data.FloorName;
      this.SpaceImageName = data.FloorPlanImage;
    
    
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 2; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
  }

  ngOnInit() {
    this.unitTempateForm = new FormGroup({
      unitname: new FormControl(''),          
      campusID: new FormControl(''), 
      buildID: new FormControl(''), 
      floorID: new FormControl(''), 
      unitID: new FormControl(''), 
      newtempname:new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
    });
    
    this.unitTempateForm.get('unitname').disable(); 
    
    this.getDeviceDetails();
  }
  
  getDeviceDetails()
  {
    try
    {
        var device_infos = [];
        let voiceLicense = localStorage.getItem("voice_license");
        var devicedata:getDeviceDetailsReq = 
        { siteId: this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          campusId:this.selectCampusId,
          floorId: parseInt(this.selectedFloorId),
          status:  this.device_list_all,
          devicetype: 0,
          device: 0, 
          spaceId: parseInt(this.selectedUnitId),
          isIndoor:1,
          isNeedRoomonly:1,
          isNeedIntercom:parseInt(voiceLicense)
         };
        
        this.apiService.getDeviceDetails(devicedata).pipe(takeUntil(this._onDestroy))
          .subscribe((DeviceDetails: any[]) => {
        
        this.DevicesInfo = DeviceDetails["apiReturn"]; 
          DeviceDetails["apiReturn"].forEach(function(data)
          {
            if(data.FilterDeviceType != NewDeviceTypeDesc.Zone)
            {
              device_infos.push(data);
            }
            if(data.FilterDeviceType == NewDeviceTypeDesc.LF)
            {
              if (data.SubType==DeviceType.DripTray)
              {
                data.FilterDeviceType =NewDeviceTypeDesc.DripTray
              }
              else
              {
               data.FilterDeviceType =NewDeviceTypeDesc.LFExiter
              }
            }
          })
          this.DeviceInfowithoutZone = device_infos;
      });
    }
    catch (err) {
      throw new Error('template-unit.component.ts' + ' - getDeviceDetails() - ' + err.message);
    }
  }
  
  public onCloseCancel = () => 
  { 
    this.thisDialogRef.close('Cancel');  
    if(!SessionCheck(this.router))
    {
        return;
    }         
         
  }

  isCheckedAll = false;
  toggleAll(event: MatCheckboxChange) {

    if (event.checked) {
      this.select_DeviceIds = [];
      this.DevicesInfo.forEach(row => {
      
        if(row.FilterDeviceType != NewDeviceTypeDesc.Zone)
        {
          var checkedid = row.DataId;
          this.select_DeviceIds.push(checkedid);
        }
      });

      
    } else {
      
      this.select_DeviceIds = [];
      this.select_DeviceIds.length = 0;
    }
    this.isCheckedAll = this.isChecked();
  }


  toggleUnitVisibility(checkedid, event: MatCheckboxChange) 
  { 
    if (event.checked) {
        const index = this.select_DeviceIds.indexOf(checkedid);
        if (index == -1) {
          this.select_DeviceIds.push(checkedid);
        }
      } else {
        const index = this.select_DeviceIds.indexOf(checkedid);
        if (index >= 0) {
          this.select_DeviceIds.splice(index, 1);
        }
      }
      this.isCheckedAll = this.isChecked();
      
  }



exists(checkedid) {
  return this.select_DeviceIds.indexOf(checkedid) > -1;
};

isChecked() {
  return this.select_DeviceIds.length === this.DeviceInfowithoutZone.length;
};


handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.unitTempateForm.controls).forEach(field => { // {1}
        const control = this.unitTempateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('template-floor.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public templateunitDetails = (templateunitformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.unitTempateForm.valid) { 
        this.saveAsTemplateForSpace(templateunitformvalue)
      }
    }
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - templatefloorDetails() - ' + err.message);
    }
  }
  
  saveAsTemplateForSpace(templateunitformvalue)
  {
    try
    {
      let saveclick = document.getElementById('btnspacetempsaveclick');
      if (this.select_DeviceIds.length==0 && this.DevicesInfo.length>0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Device to create as a new Space Template.');   
        saveclick.className = 'clstempsavebutton mat-raised-button';    
        return;
      }
      if (this.select_DeviceIds.length==0 && this.DevicesInfo.length==0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Device to duplicate or create as a Template.');    
        saveclick.className = 'clstempsavebutton mat-raised-button';    
        return;
      }
      
      saveclick.className = 'clstempsavebutton mat-raised-button disablebtn';

      let _Description = "";        
        if(templateunitformvalue.description != "")
          _Description = templateunitformvalue.description.replace(/\s+/g, ' ').trim();
        else
          _Description = "";
      
      let templateunit: saveTemplateSpace = {
        siteId:this.SiteId,
        authKey:localStorage.getItem("Authkey"),
        campusId:parseInt(templateunitformvalue.campusID),
        buildingId:parseInt(templateunitformvalue.buildID),
        floorId:parseInt(templateunitformvalue.floorID),
        spaceId:parseInt(templateunitformvalue.unitID),
        tempImageName:this.SpaceImageName.toString(),
        templateName:templateunitformvalue.newtempname.replace(/\s+/g, ' ').trim(),
        templateDescription:_Description,//templateunitformvalue.description,
        deviceIds:this.select_DeviceIds.toString()
      }
      
      let resultData = {FloorId : this.selectedFloorId, FloorName : this.selectedFloorName}
      this.technologyoverlayService.saveAsTemplateForSpace(templateunit).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: any[]) => 
      { 
      
          if(apiresponse.toString() == "true")
          {
            generateAlertMessage(this.dialog, 'Space Template added successfully.');   
            saveclick.className = 'clstempsavebutton mat-raised-button';    
            this.thisDialogRef.close(resultData); 
            this.select_DeviceIds = [];
          }
          if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Space Template added failed.');   
            saveclick.className = 'clstempsavebutton mat-raised-button';      
            this.thisDialogRef.close('Cancel'); 
            this.select_DeviceIds = [];
          }
          else if(apiresponse["condition"] == "Authfalse")
          {
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return; 
          }
          else if(apiresponse["condition"] == "Duplicate Gateway")
          {    
            generateAlertMessage(this.dialog, 'Clear Gateway already added.Please select any other devices'); 
            saveclick.className = 'clstempsavebutton mat-raised-button';      
            return;      
          }
          else if(apiresponse["condition"] == "Duplicate Clear Router")
          {    
            generateAlertMessage(this.dialog, 'Clear Router already added.Please select any other devices'); 
            saveclick.className = 'clstempsavebutton mat-raised-button';      
            return;     
          }
          else if(apiresponse["TemplateNameinfo"].length > 0)
          {                
            generateAlertMessage(this.dialog, "Space Template name ' " + apiresponse["TemplateNameinfo"] + " ' already exists");                  
            saveclick.className = 'clstempsavebutton mat-raised-button'; 
            return; 
          }
      })
    }    
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - saveAsTemplateForSpace() - ' + err.message);
    }
  }

}
